import type { ModuleID, VersionString, ViewID } from "@bestowinc/tinkertoy-core";

import { withActionFailureReporting } from "../error-telemetry";
import { trackActionLatency } from "../performance-telemetry/action-tracking";

export type ActionObservabilityArgs = {
  actionScope: "module" | "view_interaction";
  actionName: string;
  viewId: ViewID;
  viewVersion: VersionString;
  moduleId?: ModuleID;
  moduleVersion?: VersionString;
};

/**
 * Wraps an action HTTP call with failure reporting and latency metrics.
 * Performance timing is outermost so duration includes failure-reporting work.
 */
export async function withInstrumentedAction<T>(
  args: ActionObservabilityArgs,
  run: () => Promise<T>,
): Promise<T> {
  return trackActionLatency(args, () => withActionFailureReporting(args, run));
}
